<template>
  <v-divider class="primary mt-5 mb-5" />
</template>

<script>
export default {
  name: "taDividerOne",
};
</script>

<style scoped></style>
